
/* eslint-disable global-require */
const Main = r => require.ensure([], () => r(require('./Main')), 'security-bundle')
const Form = r => require.ensure([], () => r(require('./Form')), 'security-bundle')

export default [
  {
    name: 'security.roles',
    path: 'roles',
    component: Main,
    meta: { requiresAuth: true },
    children: [
      {
        name: 'security.roles.new',
        path: 'create',
        component: Form
      },
      {
        name: 'security.roles.edit',
        path: ':id/edit',
        component: Form
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/security/roles/routes.js